// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"255":"test","389":"404","962":"home"}[chunkId] || chunkId) + "." + {"255":"c3d97ca1","389":"c6fa9534","855":"41e85254","962":"15f6b5bf"}[chunkId] + ".js";
};